import { client, clientWithoutErrorHandling } from '../http';

export default {
  async generateCode({ phoneNumber, force }) {
    return await client.post('/api/no-auth/login/generate-code', { phoneNumber, force });
  },
  async authenticate({ phoneNumber, code }) {
    return await client.post('/api/no-auth/login/authenticate', { phoneNumber, code });
  },
  async isLoggedIn() {
    const response = await clientWithoutErrorHandling.get('/api/logged-in/', {
      validateStatus: status => status === 200 || status === 403,
    });
    return response.status === 200;
  },
  async loginAs({ customerToken }) {
    return await client.post('/api/no-auth/login-as', { customerToken });
  },
  async logout() {
    return await client.get('/api/logout');
  },
  async logCookies() {
    return await client.get('/api/log-cookies');
  },
  async removeToken() {
    return await client.get('/api/no-auth/remove-cookie');
  },
  async loginHelpLead({ phoneNumber, fullName, reason }) {
    return await client.post('/api/no-auth/login-help', { phoneNumber, fullName, reason });
  },
};
